import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import IconButton from './icon-button'

const BackIconButton = props => {
  const { history } = props
  const goBack = () => history.goBack()
  return <IconButton iconName='back' onClick={goBack} text={props.text} />
}

BackIconButton.propTypes = {
  text: PropTypes.string
}

export default withRouter(BackIconButton)



// WEBPACK FOOTER //
// ./src/ui/buttons/BackIconButton.js